import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { type IconName } from '../icons';
import { ChipTheme } from './interfaces';

@Component({
  selector: 'fcom-chip',
  styleUrls: ['chip.component.scss'],
  templateUrl: 'chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChipComponent {
  public readonly ChipTheme = ChipTheme;

  @Input()
  text: string;

  @Input()
  title: string;

  @Input()
  iconName: IconName;

  @Input()
  iconCategory: IconLibrary = IconLibrary.SVG_LIBRARY;

  @Input()
  theme: ChipTheme = ChipTheme.DEFAULT;

  @Input()
  disabled = false;

  @Output()
  tagClicked: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  blur: EventEmitter<Event> = new EventEmitter<Event>();
}
